export default {"src":"/_next/static/media/ic-save-white.2db8798d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};